export default __webpack_public_path__ + "d8f0bb20aa53fdd37a423c0436d417e3.png";